import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, hasAnalytics, trackPageView, track, tagClaritySession } from "./analytics";
import { captureAttribution, getAttribution, getBookingContext } from "./attribution";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ad params for Clarity: current URL first, then stored last-touch, then first-touch.
function clarityValues() {
  const params = new URLSearchParams(window.location.search);
  const { last_touch, first_touch } = getAttribution();
  const out = {};
  ["utm_source", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
    out[k] = params.get(k) || (last_touch && last_touch[k]) || (first_touch && first_touch[k]) || "";
  });
  return out;
}

function reportBooking(payload) {
  const attribution = getAttribution();
  const ctx = getBookingContext() || {};
  const lt = attribution.last_touch || {};
  track(
    "schedule_completed",
    { method: "calendly", lead_source: lt.utm_source || lt.source || "", campaign: lt.utm_campaign || "" },
    "Schedule"
  );
  if (typeof window.gtag === "function") window.gtag("event", "schedule");
  const body = JSON.stringify({
    event_uri: (payload && payload.event && payload.event.uri) || "",
    invitee_uri: (payload && payload.invitee && payload.invitee.uri) || "",
    name: ctx.name || "",
    email: ctx.email || "",
    result_id: ctx.result_id || "",
    location: ctx.location || "",
    page: ctx.page || window.location.pathname,
    attribution,
    origin: window.location.origin,
  });
  try {
    fetch(`${API}/booking`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch (e) {}
}

// Mounts once inside the Router. Captures ad attribution, initializes GA4 +
// Meta Pixel, sends a manual page_view on every route change, and reports
// every Calendly booking completion (pixel Schedule + CRM booking record).
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    const seen = new Set();
    const onMessage = (e) => {
      const d = e && e.data;
      if (!d || typeof d !== "object" || d.event !== "calendly.event_scheduled") return;
      const key = (d.payload && d.payload.invitee && d.payload.invitee.uri) || `t${Date.now()}`;
      if (seen.has(key)) return; // same booking echoed twice, not a new booking
      seen.add(key);
      reportBooking(d.payload);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  useEffect(() => {
    captureAttribution();
    tagClaritySession(clarityValues());
    if (!hasAnalytics()) return;
    trackPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
}
